import { GOOGLEMAPS_API } from '@/config-global';
import { TextField, TextFieldProps } from '@mui/material';
import { FC } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = TextFieldProps & {
  name: string;
  placeOptions?: google.maps.places.AutocompleteOptions;
  onPlaceSelected?: (places: google.maps.places.PlaceResult) => void;
};

const RHFGoogleAddressField: FC<Props> = ({
  name,
  onPlaceSelected,
  placeOptions,
  helperText,
  type,
  ...other
}) => {
  const { control, setValue } = useFormContext();
  const { i18n } = useTranslation();
  const { types = ['address'] } = placeOptions || {};

  const { ref } = usePlacesWidget({
    apiKey: GOOGLEMAPS_API,
    language: i18n.language,
    options: { types, ...placeOptions },
    onPlaceSelected:
      onPlaceSelected ||
      ((place) => {
        setValue(name, place, { shouldValidate: true });
      }),
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          autoComplete="off"
          type={type}
          inputRef={ref}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
};

export default RHFGoogleAddressField;
